import { useCallback, useEffect, useState } from 'react';

type UseCountdownReturn = {
  timeLeft: number;
  start: (seconds: number) => void;
  reset: () => void;
  isActive: boolean;
};

export const useCountdown = (): UseCountdownReturn => {
  const [timeLeft, setTimeLeft] = useState(0);

  const start = useCallback((seconds: number) => {
    setTimeLeft(seconds);
  }, []);

  const reset = useCallback(() => {
    setTimeLeft(0);
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  return {
    timeLeft,
    start,
    reset,
    isActive: timeLeft > 0,
  };
};
